module.exports = __webpack_public_path__ + "img/eye-low-vision.82433555.svg";